const actions = [
  // user
  'UPDATE_USER_INFO',
  'UPDATE_APP',

  // search
  'ADD_RECENT_SEARCH',

  // address
  'SET_ADDRESS',

  // comparable listings
  'SET_COMPARABLES',

  // market stats
  'SET_MARKET_STATS',
  'SET_UNFILTERED_MARKET_STATS',

  // top markets
  'SET_TOP_MARKETS',

  // marketing
  'SET_UNSUBSCRIBE_ALL_SUCCESS',
  'SET_UNSUBSCRIBE_RESULT',

  // median rent by bedroom
  'SET_MEDIAN_RENT_BY_BEDROOM',
];

const dispatchConstants = actions.reduce<Record<string, string>>((accumulator, value) => {
  accumulator[value] = value;
  return accumulator;
}, {});

const constants = { ...dispatchConstants };

export default constants;
